import { Host, h } from "@stencil/core";
import state from "../store";
export class GxgText {
    constructor() {
        this.href = undefined;
        this.disabled = false;
        this.target = "_self";
        this.type = "text-regular";
        this.textAlign = "start";
        this.padding = "none";
        this.maxWidth = "100%";
        this.icon = undefined;
        this.iconAlign = "center";
        this.iconAuto = false;
        this.italic = false;
    }
    textType() {
        let text;
        switch (this.type) {
            case "text-regular":
                text = (h("p", { style: { maxWidth: this.maxWidth }, class: "gxg-text" }, h("slot", null)));
                break;
            case "text-gray":
                text = (h("p", { style: { maxWidth: this.maxWidth }, class: "gxg-text--gray" }, h("slot", null)));
                break;
            case "text-quote":
                text = (h("q", { style: { maxWidth: this.maxWidth }, class: "gxg-quote" }, h("slot", null)));
                break;
            case "text-link":
                text = (h("a", { style: { maxWidth: this.maxWidth }, href: this.href, target: this.target, class: { "gxg-link": true, disabled: this.disabled } }, h("slot", null)));
                break;
            case "text-link-no-line":
                text = (h("a", { style: { maxWidth: this.maxWidth }, href: this.href, target: this.target, class: {
                        "gxg-link": true,
                        "no-line": true,
                        disabled: this.disabled,
                    } }, h("slot", null)));
                break;
            case "text-link-gray":
                text = (h("a", { style: { maxWidth: this.maxWidth }, href: this.href, target: this.target, class: { "gxg-link-gray": true, disabled: this.disabled } }, h("slot", null)));
                break;
            case "text-link-gray-no-line":
                text = (h("a", { style: { maxWidth: this.maxWidth }, href: this.href, target: this.target, class: {
                        "gxg-link-gray": true,
                        "no-line": true,
                        disabled: this.disabled,
                    } }, h("slot", null)));
                break;
            case "text-alert-error":
                text = (h("p", { style: { maxWidth: this.maxWidth }, class: "gxg-alert-error" }, h("slot", null)));
                break;
            case "text-alert-warning":
                text = (h("p", { style: { maxWidth: this.maxWidth }, class: "gxg-alert-warning" }, h("slot", null)));
                break;
            case "text-alert-success":
                text = (h("p", { style: { maxWidth: this.maxWidth }, class: "gxg-alert-success" }, h("slot", null)));
                break;
            case "button-like":
                text = (h("button", { class: { "gxg-button-like": true, disabled: this.disabled } }, h("slot", null)));
                break;
            default:
                text = (h("p", { style: { maxWidth: this.maxWidth }, class: { "gxg-text": true, disabled: this.disabled } }, h("slot", null)));
        }
        return text;
    }
    evaluateIconColor = () => {
        if (this.iconAuto) {
            return "auto";
        }
        if (state.mercury && this.type === "text-regular") {
            return "mercury";
        }
        else if (state.mercury && this.type === "text-link") {
            return "primary-enabled";
        }
        return "auto";
    };
    render() {
        return (h(Host, { class: {
                large: state.large,
                mercury: state.mercury,
                icon: this.icon !== undefined,
                "icon--center": this.iconAlign === "center",
                "icon--top": this.iconAlign === "top",
            } }, h("div", { class: "wrapper" }, this.icon ? (h("gxg-icon", { type: this.icon, color: this.evaluateIconColor() })) : null, this.textType())));
    }
    static get is() { return "gxg-text"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["text.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["text.css"]
        };
    }
    static get properties() {
        return {
            "href": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The href (for \"link\" or \"link-gray\" types"
                },
                "attribute": "href",
                "reflect": false
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables the interactive types of text"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "target": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TargetType",
                    "resolved": "\"_blank\" | \"_self\"",
                    "references": {
                        "TargetType": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/text/text.tsx",
                            "id": "src/components/text/text.tsx::TargetType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The target (for \"link\" or \"link-gray\" types"
                },
                "attribute": "target",
                "reflect": false,
                "defaultValue": "\"_self\""
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TextType",
                    "resolved": "\"button-like\" | \"text-alert-error\" | \"text-alert-success\" | \"text-alert-warning\" | \"text-gray\" | \"text-link\" | \"text-link-gray\" | \"text-link-gray-no-line\" | \"text-link-no-line\" | \"text-quote\" | \"text-regular\"",
                    "references": {
                        "TextType": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/text/text.tsx",
                            "id": "src/components/text/text.tsx::TextType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Text type"
                },
                "attribute": "type",
                "reflect": true,
                "defaultValue": "\"text-regular\""
            },
            "textAlign": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TextAlign",
                    "resolved": "\"center\" | \"end\" | \"start\"",
                    "references": {
                        "TextAlign": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/text/text.tsx",
                            "id": "src/components/text/text.tsx::TextAlign"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Text alignment"
                },
                "attribute": "text-align",
                "reflect": true,
                "defaultValue": "\"start\""
            },
            "padding": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TextPadding",
                    "resolved": "\"m\" | \"none\" | \"s\"",
                    "references": {
                        "TextPadding": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/text/text.tsx",
                            "id": "src/components/text/text.tsx::TextPadding"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Text padding"
                },
                "attribute": "padding",
                "reflect": true,
                "defaultValue": "\"none\""
            },
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Max. width"
                },
                "attribute": "max-width",
                "reflect": true,
                "defaultValue": "\"100%\""
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The gemini icon type"
                },
                "attribute": "icon",
                "reflect": false
            },
            "iconAlign": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"top\" | \"center\"",
                    "resolved": "\"center\" | \"top\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The icon alignment on the vertical axis."
                },
                "attribute": "icon-align",
                "reflect": false,
                "defaultValue": "\"center\""
            },
            "iconAuto": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "It will force the icon color to be auto"
                },
                "attribute": "icon-auto",
                "reflect": false,
                "defaultValue": "false"
            },
            "italic": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Italic (only for mercury)"
                },
                "attribute": "italic",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
}
//# sourceMappingURL=text.js.map
